module.exports = __webpack_public_path__ + "img/72.8aad1492.png";